import styled from 'styled-components';

export const TopScorerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 150px;
`;

export const TopScorerText = styled.p`
    font-size: 30px;
    font-family: Caveat, serif;
    margin: 0;
`;

export const TopScorerSubtext = styled.p`
    font-size: 17px;
    font-family: Caveat, serif;
    margin: 0;
    margin-bottom: 15px;
`;

export const TopScorerImg = styled.img`
    width: 100px;
    height: 100px;
`;
